import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ContactsPage } from "@/features/contacts/ContactsPage";

const search = z.object({
  peek: z.string().optional(),
});

export const Route = createFileRoute("/_app/contacts/")({
  validateSearch: search,
  component: () => <ContactsPage search={Route.useSearch()} />,
});
